import React from "react";
import { SITE, HERO_IMAGES } from "../mock";
import EnquiryForm from "./EnquiryForm";
import { MapPin, Building2, Home, ShoppingBag } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[640px] md:min-h-[720px] flex items-center">
      <img src={HERO_IMAGES[0]} alt="Godrej Elaris luxury apartments" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative max-w-7xl mx-auto w-full px-4 md:px-6 py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div className="text-white">
          <div className="inline-flex items-center gap-2 bg-[#C9A24B]/90 text-[#1a1a1a] px-3 py-1 rounded-full text-xs font-semibold mb-4">
            <MapPin className="w-3 h-3" /> {SITE.location.replace("At ", "")}
          </div>
          <h1 className="font-serif-display text-5xl md:text-7xl font-bold leading-tight mb-3">
            {SITE.projectName}
          </h1>
          <p className="text-[#e7d3a6] italic text-lg md:text-xl mb-5">{SITE.location}</p>

          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-white/10 border border-[#C9A24B] flex items-center justify-center">
                <Building2 className="w-4 h-4 text-[#C9A24B]" />
              </div>
              <span className="text-sm md:text-base">Residential Floors : <b>{SITE.floors}</b></span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-white/10 border border-[#C9A24B] flex items-center justify-center">
                <span className="text-[#C9A24B] text-xs font-bold">★</span>
              </div>
              <span className="text-sm md:text-base italic text-[#f3e7cb]">Godrej Elaris New Sales Lounge</span>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-white/10 border border-[#C9A24B] flex items-center justify-center shrink-0">
                <Home className="w-4 h-4 text-[#C9A24B]" />
              </div>
              <div>
                <div className="text-sm md:text-base">2, 3 &amp; 4 BHK Apartments Start At</div>
                <div className="font-serif-display text-3xl md:text-4xl font-bold text-[#C9A24B]">{SITE.startingPrice} <span className="text-base font-normal text-white/80">Onwards</span></div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-white/10 border border-[#C9A24B] flex items-center justify-center shrink-0">
                <ShoppingBag className="w-4 h-4 text-[#C9A24B]" />
              </div>
              <div>
                <div className="text-sm md:text-base">Premium Retail Space Start At</div>
                <div className="font-serif-display text-3xl md:text-4xl font-bold text-[#C9A24B]">{SITE.retailPrice} <span className="text-base font-normal text-white/80">Onwards</span></div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-3">
            <a href="#contact" className="btn-gold">Enquire Now</a>
            <a href={`tel:${SITE.phoneRaw}`} className="btn-primary border border-white/30">Call {SITE.phone}</a>
          </div>
        </div>

        <div className="lg:ml-auto lg:max-w-md w-full">
          <EnquiryForm title="Hi! Let's Connect" subtitle="Quick 30-second form • No spam • Expert call within minutes." compact source="hero_form" />
        </div>
      </div>
    </section>
  );
}
